import { useState } from "react";
import { toast } from "sonner";
import { X } from "lucide-react";
import { api } from "../lib/api";

export const SubmitBusinessModal = ({ open, onClose, cats, markets }) => {
  const [form, setForm] = useState({ name: "", phone: "", website: "", address: "", city: "", state: "", category: "", description: "" });
  const [busy, setBusy] = useState(false);
  if (!open) return null;

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.city || !form.state || !form.category) {
      toast.error("Completa nombre, ciudad, estado y categoría.");
      return;
    }
    setBusy(true);
    try {
      const res = await api.submitBusiness(form);
      toast.success(res.message || "Enviado para revisión.");
      onClose();
      setForm({ name: "", phone: "", website: "", address: "", city: "", state: "", category: "", description: "" });
    } catch {
      toast.error("No se pudo enviar. Intenta de nuevo.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-end justify-center bg-black/50 p-0 sm:items-center sm:p-4" onClick={onClose}>
      <div
        data-testid="submit-business-modal"
        className="max-h-[90vh] w-full overflow-y-auto rounded-t-3xl bg-white p-6 sm:max-w-lg sm:rounded-3xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between">
          <h3 className="font-display text-xl font-bold">Agregar un negocio</h3>
          <button onClick={onClose} data-testid="close-submit-modal" className="rounded-full p-1 hover:bg-secondary"><X className="h-5 w-5" /></button>
        </div>
        <p className="mt-1 text-sm text-muted-foreground">Tu envío pasará por revisión antes de publicarse.</p>
        <form onSubmit={submit} className="mt-4 space-y-3">
          <Input label="Nombre *" value={form.name} onChange={set("name")} testid="sb-name" />
          <div className="grid grid-cols-2 gap-3">
            <Input label="Ciudad *" value={form.city} onChange={set("city")} testid="sb-city" />
            <Input label="Estado *" value={form.state} onChange={set("state")} testid="sb-state" placeholder="CA" />
          </div>
          <div>
            <label className="mb-1 block text-xs font-semibold text-muted-foreground">Categoría *</label>
            <select data-testid="sb-category" value={form.category} onChange={set("category")} className="h-11 w-full rounded-xl border border-input bg-white px-3 outline-none focus:ring-2 focus:ring-brand/40">
              <option value="">Selecciona...</option>
              {cats.map((c) => <option key={c.slug} value={c.slug}>{c.name}</option>)}
            </select>
          </div>
          <Input label="Teléfono" value={form.phone} onChange={set("phone")} testid="sb-phone" />
          <Input label="Sitio web" value={form.website} onChange={set("website")} testid="sb-website" />
          <Input label="Dirección" value={form.address} onChange={set("address")} testid="sb-address" />
          <div>
            <label className="mb-1 block text-xs font-semibold text-muted-foreground">Descripción</label>
            <textarea data-testid="sb-description" value={form.description} onChange={set("description")} rows={3} className="w-full rounded-xl border border-input bg-white px-3 py-2 outline-none focus:ring-2 focus:ring-brand/40" />
          </div>
          <button data-testid="submit-business-btn" disabled={busy} className="h-12 w-full rounded-full bg-brand font-bold text-white transition-colors hover:bg-brand-hover disabled:opacity-60">
            {busy ? "Enviando..." : "Enviar para revisión"}
          </button>
        </form>
      </div>
    </div>
  );
};

const Input = ({ label, testid, ...rest }) => (
  <div>
    <label className="mb-1 block text-xs font-semibold text-muted-foreground">{label}</label>
    <input data-testid={testid} {...rest} className="h-11 w-full rounded-xl border border-input bg-white px-3 outline-none focus:ring-2 focus:ring-brand/40" />
  </div>
);
